import { Currency } from "@paywithglide/glide-js";
import ModalBackButton from "../components/ModalBackButton";
import TransactionCheckoutHeader from "../components/TransactionCheckoutHeader";
import { useGlideDepositConfig } from "../lib/useDepositConfig";
import SecondaryButton from "../components/SecondaryButton";
import { SectionTitle } from "../components/SectionTitle";
import { useMemo } from "react";

type Props = {
  onBack: () => void;
  currencies: Currency[];
  onSelectCurrency: (currency: Currency) => void;
};

export function ChooseCurrency({
  onBack,
  currencies,
  onSelectCurrency,
}: Props) {
  const depositConfig = useGlideDepositConfig();

  // Filter currencies based on allowedPaymentCurrencies
  const filteredCurrencies = useMemo(() => {
    if (!depositConfig.allowedPaymentCurrencies?.length) {
      // No filtering needed, use all currencies
      return currencies;
    }

    const filtered = currencies.filter((currency) =>
      depositConfig.allowedPaymentCurrencies!.includes(currency.id),
    );

    return filtered;
  }, [currencies, depositConfig.allowedPaymentCurrencies]);

  return (
    <>
      <ModalBackButton onClick={() => onBack()} />

      <TransactionCheckoutHeader title={"Receive token"} />

      <SectionTitle
        title="Choose a token"
        subtitle="Receive any token, we'll handle the conversion"
      />

      <div
        className={`mt-2 mb-2 font-medium text-sm text-[--color-text-primary]`}
      >
        {depositConfig.mode === "buy" ? (
          <>Which token do you want to buy?</>
        ) : null}
      </div>

      <div className="space-y-2">
        {filteredCurrencies.map((c) => (
          <SecondaryButton
            key={c.symbol}
            icon={
              <img
                src={c.logoUrl}
                alt={c.name}
                className="h-5 w-5 rounded-full"
              />
            }
            title={c.name}
            onClick={() => onSelectCurrency(c)}
          />
        ))}
      </div>
    </>
  );
}
